import { Modal, ModalProps, Row, Space } from 'antd'
import { ReactNode } from 'react'
import { faCheck, faLeft, faUndo } from '@fortawesome/pro-solid-svg-icons'
import IconAndTextButton from '../IconAndTextButton'

export type Props = {
  visible: boolean
  label: string
  name: string
  defaultValue: string
  input: ReactNode
  onCancel: () => void
  onSubmit: () => void
  onReset: () => void
  showReset: boolean
  additionalInfo?: ReactNode
} & Pick<ModalProps, 'getContainer'>

export default function OverrideValueModalBase({
  visible,
  label,
  name,
  defaultValue,
  input,
  onCancel = () => {},
  onSubmit = () => {},
  onReset = () => {},
  showReset,
  getContainer,
  additionalInfo
}: Props) {
  const resetButton = <IconAndTextButton key="reset" danger onClick={() => onReset()} icon={faUndo} text="Reset to Default" />
  return <>
    <Modal open={visible} title="Override Value" getContainer={getContainer}
      footer={
        <Row justify="space-between">
          {showReset === true ? resetButton : <>&nbsp;</> }
          <Space>
            <IconAndTextButton key="cancel" onClick={onCancel} icon={faLeft} text="Cancel"/>
            <IconAndTextButton key="submit" type="primary" onClick={() => onSubmit()} icon={faCheck} text="Set Value" />
          </Space>
        </Row>}
      onCancel={onCancel}
    >
      <Space direction="vertical" style={{width: '100%'}}>
        <span>The {label} for {name} is <strong>{defaultValue}</strong></span>
        {additionalInfo}
        {input}
      </Space>
    </Modal>
  </>
}